import axiosConfig from './axiosConfig';
import axios from 'axios';
import { notification } from 'antd';

export interface ApiTeamMember {
  team_member_id: number;
  user_id: number;
  project_id: number;
  project_level_role_id: number;
  team_member_role: string;
  status: string;
  user: {
    user_id: number;
    first_name: string;
    last_name: string;
    email: string;
    phone_number?: string;
    profile_picture_url?: string;
    status?: string;
    department?: {
      department_id: number;
      department_name: string;
      is_active: boolean;
    };
    company?: {
      company_id: number;
      company_name: string;
      is_active: boolean;
    };
    appLevelRole?: {
      app_level_role_id: number;
      group_name: string;
      permissions: Record<string, any>;
      is_active: boolean;
    };
    cognitoStatus?: {
      username: string;
      status: string;
      enabled: boolean;
      userCreateDate: string;
      userLastModifiedDate: string;
    };
  };
  project: {
    project_id: number;
    project_name: string;
    project_number: string;
  };
  projectLevelRole: {
    project_level_role_id: number;
    project_role_name: string;
    permissions: {
      team: string[];
      tasks: string[];
      project: string[];
      reports: string[];
      documents: string[];
    };
  };
  certificates: Array<{
    cert_id: number;
    user_id: number;
    team_member_id: number;
    file_name: string;
    docRef: number;
    file_url: string;
    s3Key: string;
    document_tags: string[] | null;
    created_at: string;
    updated_at: string;
  }>;
}

export interface ApiTeamMembersResponse {
  success: number;
  message: string;
  statusCode: number;
  data: {
    platformTeamMembers: ApiTeamMember[];
    total: number;
    limit: number;
    offset: number;
  };
  txId: string;
}

export const getAllTeamMembers = async (): Promise<ApiTeamMembersResponse | null> => {
  try {
    // Use the full URL to match your curl command
    const baseURL = process.env.REACT_APP_BASE_URL;
    const response = await axiosConfig.get(`teamMembers/getAllTeamMembers`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    });
    
    if (response.status === 200) {
      return response.data;
    }
    
    return null;
  } catch (error) {
    notification.error({
      message: 'Error',
      description: 'Failed to fetch team members. Please try again.',
    });
    return null;
  }
};



export const deleteTeamMember = async (teamMemberId: number): Promise<boolean> => {
  try {
    const response = await axiosConfig.delete(`teamMembers/deleteTeamMember/${teamMemberId}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    });   
    
    if (response.status === 200) {
      notification.success({
        message: 'Success',
        description: 'Team member deleted successfully.',
      });
      return true;
    }
    
    return false;
  } catch (error) {
    notification.error({
      message: 'Error',
      description: 'Failed to delete team member. Please try again.',
    });
    return false;
  }
}; 